import { createRouter, createWebHistory } from 'vue-router';
import ByeBye from '../components/ByeBye.vue';
import Loading from '../components/Loading.vue';
import InvalidSession from '../components/InvalidSession.vue';
import Kicked from '../components/Kicked.vue';
import UnsupportedBrowser from '../components/UnsupportedBrowser.vue';
import Welcome from '../components/Welcome.vue';
import { isRecorderMode, readStoredToken } from '../convex/auth';

export function createAppRouter() {
  const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
      {
        path: '/',
        name: 'welcome',
        component: Welcome,
      },
      {
        path: '/byebye',
        name: 'bye-bye',
        component: ByeBye,
      },
      {
        path: '/kicked/:roomSlug',
        name: 'kicked-conference',
        component: Kicked,
        props: (route) => ({
          roomSlug: Array.isArray(route.params.roomSlug) ? route.params.roomSlug[0] : route.params.roomSlug,
        }),
      },
      {
        path: '/kicked',
        name: 'kicked',
        component: Kicked,
      },
      {
        path: '/invalidsession',
        name: 'invalid-session',
        component: InvalidSession,
        props: (route) => ({
          reason: Array.isArray(route.query.reason) ? route.query.reason[0] : route.query.reason,
        }),
      },
      {
        path: '/unsupported-browser',
        name: 'unsupported-browser',
        component: UnsupportedBrowser,
      },
      {
        path: '/:roomSlug',
        name: 'conference',
        component: Loading,
        props: true,
      },
    ],
  });

  router.beforeEach((to) => {
    if (to.name !== 'conference') {
      return true;
    }

    return readStoredToken(window.sessionStorage) || isRecorderMode()
      ? true
      : {
          name: 'invalid-session',
        };
  });

  return router;
}

export default createAppRouter;
